export const Hotkeys = {
  CommandMenu: 'meta+k',
  TaskComposer: 't',
  TimelineNoteComposerDialog: 'n',
  OrderComposer: 'o',
  SubmitForm: 'meta+enter',
  ToggleInboxDone: 'e',
  ToggleInboxRead: 'u',
  Go: 'g',
  NewTaskFromText: 'meta+shift+o',
  TiptapNewTaskFromText: 'Mod-Shift-o',
  Escape: 'Escape',
  Filter: 'f',
  UploadFiles: 'ctrl+shift+u',
  CalendarWeek: 'w',
  CalendarDay: 'd',
  CalendarTimeGrid: 'shift+c',
  CalendarList: 'shift+l',
  CalendarTimeline: 'shift+t',
  CalendarPrevious: 'ArrowLeft',
  CalendarNext: 'ArrowRight',
  FacesheetCollapseAll: 'shift+ArrowLeft',
  FacesheetExpandAll: 'shift+ArrowRight',
  AIAssistant: 'meta+j',
} as const
export type Hotkeys = (typeof Hotkeys)[keyof typeof Hotkeys]

// Assumes Hotkeys.Go has recently been pressed.
export const GoToHotkeys = {
  Inbox: 'i',
  Calendar: 'c',
} as const
export type GoToHotkeys = (typeof GoToHotkeys)[keyof typeof GoToHotkeys]
